import { useContext } from "react";
import { Context } from "../../Provider";
import { theme } from "../../../../theme";
import { convertDateToUKFormat } from "../../../../utils";

const FtmInformation = () => {
    const { state } = useContext(Context);
    const { ftm } = state;

    const {
        ftm_forename,
        ftm_surname,
        ftm_street_address,
        ftm_place,
        ftm_postcode,
        ftm_email,
        ftm_contact_number,
        ftm_birth_of_date,
        ftm_gender,
        ftm_driving_license_number,
        ftm_vehicle_number,
        ftm_next_of_kin,
        ftm_next_of_kin_contact_number,
        ftm_utr_number,
        ftm_ni_number,
        ftm_business_utr_number,
        ftm_name_of_business,
        ftm_company_reg_number,
        ftm_bank_name,
        ftm_bank_sort_code,
        ftm_bank_account_number,
        ftm_profile_image_approved
    } = ftm;

    const informationList = [
        {
            title: "PERSONAL INFORMATION",
            data: [
                { name: "Full Name", value: [ftm_forename, ftm_surname].join(" ") },
                {
                    name: "Address",
                    value: [ftm_street_address, ftm_place, ftm_postcode].filter(Boolean).join(", ")
                },
                { name: "Email", value: ftm_email },
                { name: "Phone number", value: ftm_contact_number },
                { name: "Date of birth", value: convertDateToUKFormat(ftm_birth_of_date, 1) },
                {
                    name: "Gender",
                    value: ftm_gender === 0 ? "Male" : ftm_gender === 1 ? "Female" : "Non-binary"
                }
            ]
        },
        {
            title: "LICENCE AND VEHICLE DETAILS",
            data: [
                { name: "Driving Licence Number", value: ftm_driving_license_number },
                { name: "Vehicle Registration", value: ftm_vehicle_number }
            ]
        },
        {
            title: "NEXT OF KIN",
            data: [
                { name: "Next of Kin", value: ftm_next_of_kin },
                { name: "Next of Kin Contact", value: ftm_next_of_kin_contact_number }
            ]
        },
        {
            title: "TAX & INSURANCE",
            data: [
                { name: "Personal UTR Number", value: ftm_utr_number },
                { name: "NI Number", value: ftm_ni_number }
            ]
        },
        {
            title: "BUSINESS DETAILS",
            data: [
                { name: "Business UTR Number", value: ftm_business_utr_number },
                { name: "Business Name", value: ftm_name_of_business },
                { name: "Company Registration Number", value: ftm_company_reg_number }
            ]
        },
        {
            title: "BANK DETAILS",
            data: [
                { name: "Bank Name", value: ftm_bank_name },
                { name: "Bank Sort Code", value: ftm_bank_sort_code },
                { name: "Bank Account Number", value: ftm_bank_account_number }
            ]
        }
    ];

    const firstCol = informationList.slice(0, 3);
    const secondCol = informationList.slice(3);

    const InfoCard = ({ section, isRemoveBottom }) => (
        <li 
            className={`list-group-item border-0 d-flex flex-column flex-fill p-4 ${isRemoveBottom ? "" : "mb-4"} bg-gray-300 border-radius-lg`} 
            style={{minHeight: "230px"}}
        >
            <h6 className="mb-3 text-sm">
                {section.title}
                {ftm_profile_image_approved !== 1 && (
                    <i className={`material-icons opacity-10 ms-2 text-${theme.main} text-sm`}>verified </i>
                )}
            </h6>
            {section.data.map((d, idx) => (
                <span key={idx} className="mb-2 font-weight-bold text-xs">
                    {d.name}:{" "}
                    <span className="text-dark font-weight-bold ms-sm-2">
                        {d.value || "N/A"}
                    </span>
                </span>
            ))}
        </li>
    );

    return (
        <div className="row align-items-stretch">
            {[firstCol, secondCol].map((col, colIdx) => (
                <div className="col-lg-6 col-12 d-flex flex-column" key={colIdx}>
                    <ul className="list-group d-flex flex-column h-100">
                        {col.map((section, i) => (
                            <InfoCard key={i} section={section} isRemoveBottom={i === col.length - 1}/>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );
};

export default FtmInformation;